<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb p-0 d-flex align-items-center mb-primary">
            <li class="breadcrumb-item page-header d-flex align-items-center">
              <h4 class="mb-0">{{$t('my_profile')}}</h4>
            </li>
            <li class="ml-2">|</li>
            <li><a href="/crm/users/list" class="btn btn-link text-primary pl-2">Назад</a>
            </li>
          </ol>
        </nav></div></div>
    
   
    <div class="user-profile mb-primary">
      
		<div class="row">
			<div class="col-12 col-md-6">

		<div class="card position-relative card-with-shadow py-primary border-0 mb-3">
        <app-overlay-loader v-if="!dataLoaded" class=""/>
        <div class="row align-items-center" v-else>

				
          <div class="col-12">
            <div class="media pl-xl-0 align-items-center user-header-media">
              <div class="profile-pic-wrapper position-relative">

                <app-avatar
                    :avatar-class="'avatars-w-100'"
                    :img="formData.profile_picture ?
                                                            urlGenerator(formData.profile_picture.path) :
                                                            formData.profile_picture"
                    :title="formData.full_name"
                    class="mr-5 float-right"
                  />
             
              </div>

              <div class="media-body user-info-header">
                <h4>{{ formData.full_name }}</h4>

                <p class="text-muted mb-2">{{ formData.email }}</p>
                <p class="text-muted mb-2" v-for="item in formData.roles">
             
                  {{item.name}}
            
              </p>
               
               
              </div>
            </div>
          </div>
      
        </div>
      </div>
      
      <app-common-activity-show-user
            :Data="formData"
            :edit-url="selectedUrl"
            v-if="isComponent"
            :file-note-url="`crm/user`"
            component-type="person"
           
            @open-note-modal="editNote"
          />
	  </div>
		<div class="col-12 col-md-6">

      
      <app-tab :tabs="todoActivityTab" v-if="appTapShow"  class="mb-primary" type="horizontal"/>




			</div>
		
		
	</div>
		
		

  <app-common-note-modal v-if="isNoteModal" :note="noteRowData" @close-modal="closeNoteModal"/>
		
		
    </div>
   
  </div>
</template>

<script>

import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, onlyTime, onlyTimeFromTime, textTruncate, urlGenerator} from "@app/Helpers/helpers";

export default {
  name: "Profile",
	props: ["selectedUrl"],
  mixins: [FormMixin],

  data() {
    return {
      urlGenerator,
			dataLoaded: false,
			preLoader: false,
			isDealModalActive: false,
			isNoteModal: false,
			personActivitiesModal: false,
			formData: {},
			appTapShow: false,
			isComponent: false,
			name: "",
			editedUrl: "",
			activitiesList: [],
			isfileNoteFilter: true,

      todoActivityTab: [
      {
					name: this.$t("note"),
					icon: "file-text",
					component: "common-note-tab",
					props: "",
					permission: "",
				},
				{
					name: this.$t("file"),
					icon: "paperclip",
					component: "common-file-tab",
					props: "",
					permission: "",
				},
				
			],
      rowData: null,
			dealNoteModal: false,
			noteRowData: null,
			value: "",
			formatDateToLocal,
			onlyTimeFromTime,
			onlyTime,
			textTruncate,
			
    }
  },

  methods: {
   
    afterSuccess(response) {
      alert('upd');
    },
		afterSuccessFromGetEditData(response) {
			this.formData = response.data;

		
			this.todoActivityTab.forEach((el) => {
				el["props"] = {
					
					id: this.formData.id,
					contextable_type: "App\\Models\\CRM\\User\\User",
					fileSyncUrl: `crm/user/file/sync/${this.formData.id}`,
					noteSyncUrl: `crm/user/note/sync/${this.formData.id}`,
				};
			});

			this.appTapShow = true;
			this.isComponent = true;
			this.dataLoaded = true;
		},

		updateRequest() {
			this.isComponent = false;
			this.axiosGet(this.selectedUrl).then((response) => {
				this.formData = response.data;
				this.name = this.formData.name;
				this.isComponent = true;
			}).catch((error) => console.log(error));
		},

		updateDealList() {
			this.$hub.$on("deal-update-list", (value = true) => {
				if (value) {
					this.updateRequest();
				}
			});
		},
		updateTagList() {
			this.$hub.$on("tag-list", (value = true) => {
				if (value) {
					this.updateRequest();
				}
			});
		},

		editActivity(activity) {
			this.editedUrl = `crm/activities/${activity.id}`;
			this.rowData = activity;
			this.personActivitiesModal = true;
		},
		openDealModal() {
			this.isDealModalActive = true;
			setTimeout(function () {
				$("#deal-modal").modal("show");
			});
		},
		closeDealModal() {
			this.isDealModalActive = false;
			$("#deal-modal").modal("hide");
		},
		closeActivityModal() {
			this.personActivitiesModal = false;
			$("#common-activity-modal").modal("hide");
		},

		editNote(activity) {
			this.isNoteModal = true;
			this.noteRowData = activity;
			setTimeout(() => {
				$("#note-modal").modal("show");
			});
		},
		closeNoteModal() {
			this.isNoteModal = false;
			$("#note-modal").modal("hide");
		},
	},

	mounted() {
		this.updateDealList();
		this.updateTagList();
	},
}
</script>

<style>
.user-profile .card {
  min-height: 190px;
}
.avatars-w-100 {width: 100px; height: 100px; overflow:hidden; border-radius:50%;}
.avatars-w-100 img {width: 100px; height: auto !important; }
.avatars-w-100 img.rounded-circle {border-radius:0 !important;}
</style>
